import { render, staticRenderFns } from "./ElepantSecretPrescriptionList.vue?vue&type=template&id=5a729984&scoped=true"
import script from "./ElepantSecretPrescriptionList.vue?vue&type=script&lang=js"
export * from "./ElepantSecretPrescriptionList.vue?vue&type=script&lang=js"
import style0 from "./ElepantSecretPrescriptionList.vue?vue&type=style&index=0&id=5a729984&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a729984",
  null
  
)

export default component.exports